import { render, staticRenderFns } from "./BenefitBlock.vue?vue&type=template&id=b94e485a&scoped=true&"
import script from "./BenefitBlock.vue?vue&type=script&lang=js&"
export * from "./BenefitBlock.vue?vue&type=script&lang=js&"
import style0 from "./BenefitBlock.vue?vue&type=style&index=0&id=b94e485a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94e485a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
